import SSRIcon from "./SSRIcon.mjs";
export * from "./SSRIcon.mjs";
var lib_default = SSRIcon;
export {
  lib_default as default
};
